import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	placeholder: {
		id: 'servicedesk-insight-attribute-views.bitbucket-repo.placeholder',
		defaultMessage: 'No Bitbucket repositories selected',
		description: 'Message displayed when there are no bitbucket repos selected for an attribute',
	},
});
